import React from 'react';

/**
 * Renders the opening guided-scroll chapter without duplicating the persistent
 * Milan brand mark. Accepts no props.
 *
 * @returns {React.ReactElement} Chapter zero with an accessible Milan heading,
 *   restrained subtitle, and quiet decorative scroll cue.
 * @sideEffects Has no external side effects beyond React rendering.
 */
const Hero = () => {
  return (
    <section
      className="hero-chapter"
      data-chapter-index={0}
      data-testid="hero-section"
      id="hero"
      aria-labelledby="hero-title"
    >
      <div className="hero-chapter__content">
        <h1 id="hero-title" className="sr-only">Milan</h1>
        <h2 className="sr-only">Intentional Dating App & Mindful Relationship Space</h2>
        <p className="hero-chapter__subtitle">Built for intention.</p>
        <p className="hero-chapter__positioning">
          A relationship space built on reflection to help you understand what you want, introducing you to people who match your depth instead of a random feed of profiles.
        </p>

        <div className="hero-chapter__scroll-cue" aria-hidden="true">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="hero-chapter__scroll-arrow"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Hero;
